import fp from 'lodash/fp'

const toInt32 = (value) => {
  const numericValue = Number(value)

  if (!Number.isFinite(numericValue) || numericValue === 0) {
    return 0
  }

  const truncatedValue = Math.trunc(numericValue)
  const twoToThirtyTwo = 4294967296
  let unsignedValue = truncatedValue % twoToThirtyTwo

  if (unsignedValue < 0) {
    unsignedValue += twoToThirtyTwo
  }

  return unsignedValue >= 2147483648
    ? unsignedValue - twoToThirtyTwo
    : unsignedValue
}

export const prettify = (num, params) => {
  if (!fp.isNumber(num)) {
    return num
  }

  const { floatPartSize, groupSize, delimiter } = {
    groupSize: 3,
    delimiter: ' ',
    ...params,
  }

  const pattern = new RegExp(
    `\\d(?=(\\d{${groupSize}})+${floatPartSize > 0 ? '\\.' : '$'})`,
    'g'
  )
  return num
    .toFixed(Math.max(0, toInt32(floatPartSize)))
    .replace(pattern, `$&${delimiter}`)
}
